'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Accordion = void 0;
const $ = require("jquery");
class Accordion {
    constructor() {
        $('.trigSwitchAccordion').on('click', (e) => {
            const number = $(e.currentTarget).attr('data-number');
            const isOpen = $(e.currentTarget).attr('data-is-open');
            if (isOpen === 'false') {
                $(`.bulletAccordion[data-number=${number}]`).stop().slideDown('slow');
                $(e.currentTarget).attr('data-is-open', 'true');
            }
            else {
                $(`.bulletAccordion[data-number=${number}]`).stop().slideUp('slow');
                $(e.currentTarget).attr('data-is-open', 'false');
            }
        });
    }
}
exports.Accordion = Accordion;
exports.default = Accordion;
